module.exports = __webpack_public_path__ + "img/pencil.f48a09a3.svg";